export const ProjectType = {
  standard: 'standard',
  experimental: 'experimental',
} as const;

export type ProjectType = typeof ProjectType[keyof typeof ProjectType];
